<template>
  <div class="license">
    <p>《信息授权协议》(以下简称“本协议”)是由【深圳致复科技有限公司】(以下简称“i致富平台”、“i致富” 或“我们”)与用户(以下简称“您”)就个人信息共享所订立的有效合约，你通过本页面点击确认，即表示您同意接受本协议的全部约定内容以及本协议有关的已经发布或将来可能发布的各项规则、页面展示、操作流程、公告或通知（以下统称“规则”）。</p>
    <h4>一、当您通过本页面使用我们提供的【第三方产品推荐】服务时，为了增加您的申请贷款通过机会或提高您的授信额度，我们会对您的个人信息会进行共享。为了您的合法权益，请您在使用本服务前务必仔细阅读本协议的全部内容(特别是以粗体/下划线标注的内容)。如果您不同意本协议的任意内容，或者无法准确理解本协议任何条款的含义，请不要进行授权及后续操作。</h4>
    <h4>二、您同意本协议以数据电文形式订立。如您通过网络页面点击“同意”或“注册”或“申请”或“接受用户授权协议”(以网页显示为准)，即视为您已阅读理解本协议的全部内容并同意我们出于相关页面所述目的，将您的个人信息通过加密通道的方式提供给为您提供【账号注册、授信审核、贷款】等服务的其他个人信息处理者（以下简称“第三方”），账号能否注册成功、授信审核能否通过、能否申请贷款等相关服务以您和第三方的约定为准。</h4>
    <h4>三、本协议中共享的个人信息含个人敏感信息及其他个人信息，包括但不限于：</h4>
    <p>1.您的身份信息，<span class="license-font">包括但不限于您的姓名、性别、现居住住址、电话号码、身份证号等信息；</span></p>
    <p>四、你同意并授权我们将您的上述信息共享给第三方，但我们与第三方在开展上述信息共享前，会严格要求第三方对在信息共享中所获取的您的上述信息予以保密并且依照相关法律法规或者本协议的约定使用您的上述信息。<span class="license-font">如果您不希望向第三方提供上述信息，请勿点击授权。</span></p>
    <h4>目前，我们会将您的上述信息共享给下述第三方渠道或产品：</h4>
    <h4>1、中国平安陆金通</h4>
    <h4>五、您理解，第三方服务由相应的第三方就以上服务及处理您个人信息的安全性独立承担责任。请您在授权同意前，仔细阅读并理解第三方的服务协议与隐私政策。因该第三方服务或其处理您的个人信息产生的纠纷，或第三方服务违反相关法律法规或者协议的约定，或您在使用第三方服务过程中遭受了损失，请您与第三方协商解决。</h4>
    <h4>六、您同意，凡因本协议引起的任何与之有关的争议、纠纷，首先通过友好协商的方式解决，如协商不能达成一致的，任何一方均可向我们所在地有管辖权的人民法院提起诉讼。</h4>
    <h4>七、您同意本协议中的授权不可撤回或撤销。</h4>
    <p>八、本协议未尽事宜参照《服务协议》执行；若《服务协议》与本协议有冲突的，以本协议为准。</p>
    <p class="license-foot">签署日期：【2022-02-18】</p>
  
  
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.license {
  padding: 15px;
  font-size: 14px;
  text-align: left;
  text-indent: 2em;
  line-height: 2;
  .license-foot{
    text-align: right;
    margin-top: 20px;
  }
  .license-font{
    font-weight: bold;
  }
}

</style>